var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.authenticatorSrc != null)?_c('img',{attrs:{"src":_vm.authenticatorSrc}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }